var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketingStatusClosedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    className: "custom-lock-on-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-lock-on"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect-lock-on",
    width: 24,
    height: 24,
    transform: "translate(532.775 21)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mask-group-lock-on",
    transform: "translate(-532.775 -21)",
    clipPath: "url(#clip-path-lock-on)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-lock-on-outline",
    transform: "translate(499.526 2.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-lock-on",
    d: "M42.25,30V27a3,3,0,1,1,6,0v3m-6,0H40v7.5H50.5V30h-2.25m-6,0h6",
    fill: "none",
    stroke: "#ff8484",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    className: "path-lock-on"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketingStatusClosedIcon);
export default __webpack_public_path__ + "static/media/ticketing-status-closed-icon.a6fc98b48868daf4c21fe9dadf0e8794.svg";
export { ForwardRef as ReactComponent };